import ClampExpandable from './ClampExpandable';

function getMarginHeight(el) {
  const topMargin = parseInt(getComputedStyle(el).getPropertyValue('margin-top'), 10);
  const bottomMargin = parseInt(getComputedStyle(el).getPropertyValue('margin-bottom'), 10);
  return topMargin + bottomMargin;
}

export default class ClampExpandableList extends ClampExpandable {
  clampHeight = null;

  constructor(el) {
    super(el);

    this.itemTag = el.getAttribute('data-item-selector');
    this.items = [...this.body.querySelectorAll(`.${this.options.classNames.item}`)];

    if (this.itemTag && this.items.length === 0) {
      this.items = [...this.body.querySelectorAll(this.itemTag)];
      this.items.forEach((item) => {
        item.classList.add(this.options.classNames.item);
      });
    }

    this.setMaxHeight(null);

    const widthObserver = new ResizeObserver((entries) => {
      entries.forEach(() => {
        this.#calcClampHeight();
      });
    });

    this.#calcClampHeight();
    widthObserver.observe(this.body);
    window.addEventListener('resize', () => {
      this.setMaxHeight(null);
    });

    // this.checkClamping();
  }

  expand(animation = true) {
    if (this.expanded && !this.clamping) return;

    this.expanded = true;
    if (animation) {
      this.setMaxHeight(this.body.clientHeight);
      this.el.classList.add(this.options.classNames.expanded);
      this.setMaxHeight(this.body.scrollHeight);
      this.body.addEventListener(
        'transitionend',
        () => {
          this.setMaxHeight(null);
        },
        { once: true }
      );
    } else {
      this.setMaxHeight(null);
      this.el.classList.add(this.options.classNames.expanded);
    }
  }

  collapse(animation = true) {
    if (!this.expanded && !this.clamping) return;

    this.expanded = false;
    if (animation) {
      this.setMaxHeight(this.body.scrollHeight);
      setTimeout(() => {
        this.setMaxHeight(this.clampHeight);
      }, 5);
      this.body.addEventListener(
        'transitionend',
        () => {
          this.setMaxHeight(null);
          this.el.classList.remove(this.options.classNames.expanded);
        },
        { once: true }
      );
    } else {
      this.el.classList.remove(this.options.classNames.expanded);
      this.setMaxHeight(this.clampHeight);
    }
  }

  #calcClampHeight() {
    let lHeight = 0;
    for (let i = 0; i < this.options.numLines && i < this.items.length; i++) {
      const item = this.items[i];
      lHeight += item.offsetHeight + getMarginHeight(item);
    }
    this.clampHeight = lHeight;
  }

  setClamping() {
    if (this.items) {
      this.clamping = this.items.length > this.options.numLines;
    }
  }
}
